import React, { useLayoutEffect, useRef } from "react";
import { renderLotteryJar } from "../shared/lottery-jar-core.mjs";

export default function LotteryJar({ students, contextKey, phase, winner, status }) {
  const containerRef = useRef(null);
  useLayoutEffect(() => {
    const render = () => renderLotteryJar(containerRef.current, { students, contextKey, phase, winner, status });
    render();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(render);
    observer?.observe(containerRef.current);
    return () => {
      observer?.disconnect();
      containerRef.current?.__lotteryMotionStop?.();
    };
  }, [students, contextKey, phase, winner, status]);
  return <div ref={containerRef} />;
}
